import { render, staticRenderFns } from "./DistributionList.vue?vue&type=template&id=7e95376c"
import script from "./DistributionList.js?vue&type=script&lang=js&external"
export * from "./DistributionList.js?vue&type=script&lang=js&external"
import style0 from "./DistributionList.vue?vue&type=style&index=0&id=7e95376c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports